
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class InvoiceObjectionModel extends Model<InvoiceObjectionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'invoiceObjection.property.id', isHidden: true },
		{ name: 'companyId', type: 'guid', languageString: 'invoiceObjection.property.companyId' },
		{ name: 'documentNo', type: 'string', languageString: 'invoiceObjection.property.documentNo' },
		{ name: 'comment', type: 'string', languageString: 'invoiceObjection.property.comment' },
		{ name: 'userId', type: 'guid', languageString: 'invoiceObjection.property.userId' },
		{ name: 'created', type: 'Date', languageString: 'invoiceObjection.property.created', isHidden: true },
		{ name: 'registeredDate', type: 'Date', languageString: 'invoiceObjection.property.registeredDate' },
		{ name: 'reasonId', type: 'guid', languageString: 'invoiceObjection.property.reasonId' },
		{ name: 'brandId', type: 'guid', languageString: 'invoiceObjection.property.brandId' }
	];
	[key: string]: any;
	
	public id?: string;
	public companyId?: string;
	public documentNo: string;
	public comment: string;
	public userId?: string;
	public created?: Date;
	public registeredDate?: Date;
	public reasonId?: string;
	public brandId?: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.companyId = undefined;
		this.documentNo = '';
		this.comment = '';
		this.userId = undefined;
		this.created = undefined;
		this.registeredDate = undefined;
		this.reasonId = undefined;
		this.brandId = undefined;
		
	}
	getProperties(){
		return InvoiceObjectionModel.classProperties;
	}
}

